export default "__VITE_ASSET__CnxNLvFo__"